import type { ReactNode } from "react";

import { detectLocale } from "@/i18n/detect-locale";
import { LocaleProvider } from "@/i18n/locale-context";

interface NonLocaleRouteProps {
  children: ReactNode;
}

export function NonLocaleRoute({ children }: NonLocaleRouteProps): JSX.Element {
  const locale = detectLocale();
  return <LocaleProvider locale={locale}>{children}</LocaleProvider>;
}
